function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module link/autolink
 */
import { Plugin } from 'ckeditor5/src/core';
import { TextWatcher, getLastTextLine } from 'ckeditor5/src/typing';
import { addLinkProtocolIfApplicable } from './utils';
var MIN_LINK_LENGTH_WITH_SPACE_AT_END = 4; // Ie: "t.co " (length 5).
// This was a tweak from https://gist.github.com/dperini/729294.

var URL_REG_EXP = new RegExp( // Group 1: Line start or after a space.
'(^|\\s)' + // Group 2: Detected URL (or e-mail).
'(' + // Protocol identifier or short syntax "//"
// a. Full form http://user@foo.bar.baz:8080/foo/bar.html#baz?foo=bar
'(' + '(?:(?:(?:https?|ftp):)?\\/\\/)' + // BasicAuth using user:pass (optional)
'(?:\\S+(?::\\S*)?@)?' + '(?:' + // IP address dotted notation octets
// excludes loopback network 0.0.0.0
// excludes reserved space >= 224.0.0.0
// excludes network & broadcast addresses
// (first & last IP address of each class)
'(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])' + '(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}' + '(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))' + '|' + '(' + // Do not allow `www.foo` - see https://github.com/ckeditor/ckeditor5/issues/8050.
'((?!www\\.)|(www\\.))' + // Host & domain names.
"(?![-_])(?:[-_a-z0-9\\u00a1-\\uffff]{1,63}\\.)+" + // TLD identifier name.
"(?:[a-z\\u00a1-\\uffff]{2,63})" + ')' + ')' + // port number (optional)
'(?::\\d{2,5})?' + // resource path (optional)
'(?:[/?#]\\S*)?' + ')' + '|' + // b. Short form (either www.example.com or example@example.com)
'(' + '(www.|(\\S+@))' + // Host & domain names.
"((?![-_])(?:[-_a-z0-9\\u00a1-\\uffff]{1,63}\\.))+" + // TLD identifier name.
"(?:[a-z\\u00a1-\\uffff]{2,63})" + ')' + ')$', 'i');
var URL_GROUP_IN_MATCH = 2;
/**
 * The autolink plugin.
 *
 * @extends module:core/plugin~Plugin
 */

var AutoLink = /*#__PURE__*/function (_Plugin) {
  _inherits(AutoLink, _Plugin);

  var _super = _createSuper(AutoLink);

  function AutoLink() {
    _classCallCheck(this, AutoLink);

    return _super.apply(this, arguments);
  }

  _createClass(AutoLink, [{
    key: "init",
    value:
    /**
     * @inheritDoc
     */
    function init() {
      var _this = this;

      var editor = this.editor;
      var selection = editor.model.document.selection;
      selection.on('change:range', function () {
        // Disable plugin when selection is inside a code block.
        _this.isEnabled = !selection.anchor.parent.is('element', 'codeBlock');
      });

      this._enableTypingHandling();
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "afterInit",
    value: function afterInit() {
      this._enableEnterHandling();

      this._enableShiftEnterHandling();
    }
    /**
     * Enables autolinking on typing.
     *
     * @private
     */

  }, {
    key: "_enableTypingHandling",
    value: function _enableTypingHandling() {
      var _this2 = this;

      var editor = this.editor;
      var watcher = new TextWatcher(editor.model, function (text) {
        // 1. Detect <kbd>Space</kbd> after a text with a potential link.
        if (!isSingleSpaceAtTheEnd(text)) {
          return;
        } // 2. Check text before last typed <kbd>Space</kbd>.


        var url = getUrlAtTextEnd(text.substr(0, text.length - 1));

        if (url) {
          return {
            url: url
          };
        }
      });
      var input = editor.plugins.get('Input');
      watcher.on('matched:data', function (evt, data) {
        var batch = data.batch,
            range = data.range,
            url = data.url;

        if (!input.isInput(batch)) {
          return;
        }

        var linkEnd = range.end.getShiftedBy(-1); // Executed after a space character.

        var linkStart = linkEnd.getShiftedBy(-url.length);
        var linkRange = editor.model.createRange(linkStart, linkEnd);

        _this2._applyAutoLink(url, linkRange);
      });
      watcher.bind('isEnabled').to(this);
    }
    /**
     * Enables autolinking on the <kbd>Enter</kbd> key.
     *
     * @private
     */

  }, {
    key: "_enableEnterHandling",
    value: function _enableEnterHandling() {
      var _this3 = this;

      var editor = this.editor;
      var model = editor.model;
      var enterCommand = editor.commands.get('enter');

      if (!enterCommand) {
        return;
      }

      enterCommand.on('execute', function () {
        var position = model.document.selection.getFirstPosition();

        if (!position.parent.previousSibling) {
          return;
        }

        var rangeToCheck = model.createRangeIn(position.parent.previousSibling);

        _this3._checkAndApplyAutoLinkOnRange(rangeToCheck);
      });
    }
    /**
     * Enables autolinking on the <kbd>Shift</kbd>+<kbd>Enter</kbd> keyboard shortcut.
     *
     * @private
     */

  }, {
    key: "_enableShiftEnterHandling",
    value: function _enableShiftEnterHandling() {
      var _this4 = this;

      var editor = this.editor;
      var model = editor.model;
      var shiftEnterCommand = editor.commands.get('shiftEnter');

      if (!shiftEnterCommand) {
        return;
      }

      shiftEnterCommand.on('execute', function () {
        var position = model.document.selection.getFirstPosition();
        var rangeToCheck = model.createRange(model.createPositionAt(position.parent, 0), position.getShiftedBy(-1));

        _this4._checkAndApplyAutoLinkOnRange(rangeToCheck);
      });
    }
    /**
     * Checks if the passed range contains a linkable text.
     *
     * @param {module:engine/model/range~Range} rangeToCheck
     * @private
     */

  }, {
    key: "_checkAndApplyAutoLinkOnRange",
    value: function _checkAndApplyAutoLinkOnRange(rangeToCheck) {
      var model = this.editor.model;

      var _getLastTextLine = getLastTextLine(rangeToCheck, model),
          text = _getLastTextLine.text,
          range = _getLastTextLine.range;

      var url = getUrlAtTextEnd(text);

      if (url) {
        var linkRange = model.createRange(range.end.getShiftedBy(-url.length), range.end);

        this._applyAutoLink(url, linkRange);
      }
    }
    /**
     * Applies a link on a given range.
     *
     * @param {String} url The URL to link.
     * @param {module:engine/model/range~Range} range The text range to apply the link attribute to.
     * @private
     */

  }, {
    key: "_applyAutoLink",
    value: function _applyAutoLink(link, range) {
      var _this5 = this;

      var model = this.editor.model;

      if (!this.isEnabled || !isLinkAllowedOnRange(range, model)) {
        return;
      } // Enqueue change to make undo step.


      model.enqueueChange(function (writer) {
        var defaultProtocol = _this5.editor.config.get('link.defaultProtocol');

        var parsedUrl = addLinkProtocolIfApplicable(link, defaultProtocol);
        writer.setAttribute('linkHref', parsedUrl, range);
      });
    }
  }], [{
    key: "pluginName",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return 'AutoLink';
    }
  }]);

  return AutoLink;
}(Plugin); // Check if text should be evaluated by the plugin in order to reduce number of RegExp checks on whole text.


export { AutoLink as default };

function isSingleSpaceAtTheEnd(text) {
  return text.length > MIN_LINK_LENGTH_WITH_SPACE_AT_END && text[text.length - 1] === ' ' && text[text.length - 2] !== ' ';
}

function getUrlAtTextEnd(text) {
  var match = URL_REG_EXP.exec(text);
  return match ? match[URL_GROUP_IN_MATCH] : null;
}

function isLinkAllowedOnRange(range, model) {
  return model.schema.checkAttributeInSelection(model.createSelection(range), 'linkHref');
}